import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './components/auth/LoginPage';
import AppShell from './components/layout/AppShell';
import SharesPage from './pages/SharesPage';
import SearchPage from './pages/SearchPage';
import SettingsPage from './pages/SettingsPage';
import ItemDetailPage from './pages/ItemDetailPage';
import FolderDetailPage from './pages/FolderDetailPage';
import ContactsPage from './pages/ContactsPage';
import ShareTargetPage from './pages/ShareTargetPage';
import BlockedPage from './pages/BlockedPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AiPage from './pages/AiPage';
import BotsPage from './pages/BotsPage';
import EmailsPage from './pages/EmailsPage';
import DocPage from './pages/DocPage';
import DocumentsPage from './pages/DocumentsPage';
import DocumentViewPage from './pages/DocumentViewPage';
import StatusPage from './pages/StatusPage';

function AppRoutes() {
  const { user, isBlocked, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  if (isBlocked) {
    return <BlockedPage />;
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<SharesPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/items/:itemId" element={<ItemDetailPage />} />
        <Route path="/shared" element={<Navigate to="/" replace />} />
        <Route path="/shared-with-me" element={<Navigate to="/" replace />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/folders" element={<Navigate to="/" replace />} />
        <Route path="/folders/:folderId" element={<FolderDetailPage />} />
        <Route path="/ai" element={<AiPage />} />
        <Route path="/bots" element={<BotsPage />} />
        <Route path="/emails" element={<EmailsPage />} />
        <Route path="/docs/:docId" element={<DocPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/documents/:docId/view" element={<DocumentViewPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/status" element={<StatusPage />} />
      </Route>
      <Route path="/share" element={<ShareTargetPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
